import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { horizontalStepperRepo } from '../../../configs/utils';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import SharedPropsService from "../../../SharedPropsService";
import { ACTION } from "./types";
import { goBack, leadToPayment } from "./actions";
export const template = async (principalLoanAmount, lenderId, height, stepper, bankName, bankAccountNumber, ifscCode, amountSelected) => {
    return {
        layout: {
            id: ROUTE.PAYMENT_OPTIONS,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "repaymentDC", type: WIDGET.REPAYMENT_PAGE
                }
            ]
        },
        datastore: {
            repaymentDC: {
                height: height,
                stepper: stepper,
                bankName: `${bankName}`,
                bankAccountNumber: `${bankAccountNumber}`,
                ifscCode: `${ifscCode}`,
                principalLoanAmount: `${amountSelected}`,
                backPressAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.PAYMENT_OPTIONS,
                    payload: {}
                },
                paymentAction: {
                    type: ACTION.PAYMENT_DASHBOARD,
                    routeId: ROUTE.PAYMENT_OPTIONS,
                    payload: {
                        amountSelected: `${amountSelected}`
                    }
                },
                popupClosed: false,
                showError: false,
                disableButton: false
            },
        },
    };
};
export const paymentOptionsMf = {
    onLoad: async ({ network, getHeight }, { amountSelected }) => {
        const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
        const principalLoanAmount = userContextResponse.data.linkedCredits[0].principalOutStandingAmount;
        const response = await network.get(`${api.userProfile}${userContextResponse.data.linkedBorrowerAccounts[0].accountId}`, {
            headers: await getAppHeader(),
        });
        const bankName = response.data.bankDetails.bankName;
        const bankAccountNumber = response.data.bankDetails.accountNumber;
        const ifscCode = response.data.bankDetails.ifscCode;
        const lenderId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
        await SharedPropsService.setUser(userContextResponse.data);
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(principalLoanAmount, lenderId, getHeight(), stepper, bankName, bankAccountNumber, ifscCode, amountSelected));
    },
    actions: {
        [ACTION.PAYMENT_DASHBOARD]: leadToPayment,
        [ACTION.GO_BACK]: goBack,
    },
};
